import {Routing} from 'nutshell-core/routing';

import {writeLocalStorage} from '../../util/localStorage';

import {stripUndefinedProperties} from './strip-undefined-properties';

/**
 * Thunk, returns a function to reset filters and search parameters to the default
 *
 * @param  {string} basePath     - Path of the page we're resetting
 * @param  {object} oldUrlParams - Current page's url parameters
 * @param  {string} defaultSerach- Default search to grab filters and search from
 * @param  {function} navigate   - React-router's replace or push function
 * @return {function}              Function to change query params of page
 */
export function resetUrlFilters(
    basePath: string,
    oldUrlParams: any,
    defaultSearch: string,
    navigate: (...args: any) => any,
    persistToLocalStorageKey?: string
) {
    /**
     * This will then call react-router's replace method with the new search
     * value generated from report params.
     *
     * Takes an object of parameters for a given key, merges it with existing
     * @param  {Object} newParams        - New url parameters (i.e. {report: {gap: 'm'})
     * @param  {boolean} [shouldMerge]   - Should each parameter object be merged to the corresponding existing param object, or replace it entirely?
     * @return {void}
     */
    return function () {
        const newUrlParamString = defaultSearch.slice(1); // Remove "?"
        const newUrlParams = Routing.deparam(newUrlParamString);

        const params = {
            ...oldUrlParams,
            filter: {
                ...newUrlParams.filter,
            },
            q: newUrlParams.q,
        } as const;

        const cleanParams = stripUndefinedProperties(params);
        const newSearch = Routing.param(cleanParams);

        navigate({
            pathname: basePath,
            search: `?${newSearch}`,
        });

        if (persistToLocalStorageKey) {
            writeLocalStorage(persistToLocalStorageKey, newSearch);
        }
    };
}
